import { Pipe, PipeTransform } from '@angular/core';
import { InsoleComponent, InsoleComponentsGroups } from '../insole-component/components-config';


@Pipe({
    name: 'filterByGroup',
    pure: false
})
export class FilterByGroup implements PipeTransform {
    transform(components: InsoleComponent[], group: InsoleComponentsGroups): any {
        if (!components) return [];
        if (!group) return components;

        return components.filter(component => component.group === group);
    }
}